import { useQuery } from "@tanstack/react-query";

import getTemplateAndFormData from "./getTemplateAndFormData";

interface UseTemplateDataArgs {
  templateSlug?: string;
  stateSlug?: string;
}

const useTemplateData = ({ templateSlug, stateSlug }: UseTemplateDataArgs) => {
  return useQuery({
    queryKey: ["templateData", templateSlug, stateSlug || "general"],
    queryFn: async () => {
      if (!templateSlug) {
        throw new Error("Template slug is required");
      }

      const result = await getTemplateAndFormData({
        templateSlug,
        stateSlug: stateSlug || "general",
      });

      if (!result.formData) {
        throw new Error("Form data not found for the given template slug");
      }

      return result;
    },
    enabled: !!templateSlug,
  });
};

export default useTemplateData;
